import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const UtilizacionContenedoresTransporte = ({ selectedIndustries = [], onBarClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);

  const allLabels = ['Construcción', 'Automotriz', 'Servicios logísticos', 'Alimentos', 'Retail', 'Manufactura', 'Salud/Farmacéutica'];


  const utilizationData2023 = {
    Construcción: 77,
    Automotriz: 83,
    'Servicios logísticos': 77,
    Alimentos: 77,
    Retail: 53,
    Manufactura: 67,
    'Salud/Farmacéutica': 78,
  };


  const utilizationData2024 = {
    Construcción: 93,
    Automotriz: 91,
    'Servicios logísticos': 92,
    Alimentos: 87,
    Retail: 88,
    Manufactura: 97,
    'Salud/Farmacéutica': 90,
  };

  const colorMap = {
    utilization2023: '#A2AEBB',
    utilization2024: '#B0B0B0',
  };

  const labels = selectedIndustries.length > 0 ? selectedIndustries : allLabels;
  const utilizationValues2023 = labels.map((label) => utilizationData2023[label]);
  const utilizationValues2024 = labels.map((label) => utilizationData2024[label]);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: 'Utilización de contenedores (2022)',
        data: utilizationValues2023,
        backgroundColor: colorMap.utilization2023,
      },
      {
        label: 'Utilización de contenedores (2023)',
        data: utilizationValues2024,
        backgroundColor: colorMap.utilization2024,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 20,
        bottom: 20,
        left: 10,
        right: 10,
      },
    },
    plugins: {
      legend: {
        position: 'top',
        labels: {
          boxWidth: 15,
          padding: 20,
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
      datalabels: {
        color: '#000',
        font: {
          weight: 'bold',
          size: 10,
        },
        formatter: (value) => `${value}`,
        anchor: 'end',
        align: 'end',
        offset: -5,
        clip: false,
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        max: 100,
        ticks: {
          stepSize: 10,
        },
      },
      y: {
        categoryPercentage: 0.7,
        barPercentage: 0.5,
        ticks: {
          font: {
            size: 14,
          },
        },
      },
    },
  };

  const infoContent = {
    Analisis: 'La gráfica muestra el nivel de utilización de contenedores y camiones de carga por industria durante 2022 y 2023. Los resultados evidencian un notable incremento en la eficiencia del transporte, con avances significativos en sectores como Manufactura, Servicios logísticos y Construcción. Este indicador refleja una mejor planificación de cargas, mayor aprovechamiento de capacidad y optimización de recursos en la operación logística',
    formulas: {
      utilizacionContenedores: '(Espacio utilizado en contenedores / Espacio total disponible en contenedores) × 100',
    },
    description: 'Esta gráfica analiza la utilización de contenedores en diversas industrias durante los años 2022 y 2023. Evaluando la eficiencia en la logística y el transporte.',
  };
  

  return (
    <div style={{ maxWidth: '1000px', height: '480px', margin: '0 auto', padding: '20px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
        <p><strong>Análisis:</strong> {infoContent.Analisis}</p>
          <p><strong>Fórmulas:</strong></p>
          <p>Utilización de Contenedores: {infoContent.formulas.utilizacionContenedores}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
         
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
  
};

export default UtilizacionContenedoresTransporte;
